var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = !_vm.loadding ? _vm.hasType("10") : null
  var m1 = !_vm.loadding ? _vm.hasType("20") : null
  var m2 = !_vm.loadding ? _vm.hasType("30") : null
  var m3 = !_vm.loadding ? _vm.hasType("40") : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        m2: m2,
        m3: m3,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }